import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = { class: "relative mb-6 overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6" }
const _hoisted_3 = { class: "relative flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }
const _hoisted_4 = { class: "rounded-2xl bg-white/10 px-4 py-3 text-sm text-blue-50" }
const _hoisted_5 = { class: "mt-1 text-xl font-bold" }
const _hoisted_6 = { class: "mb-6 rounded-2xl border border-slate-100 bg-white p-4 shadow-sm" }
const _hoisted_7 = { class: "grid gap-4 lg:grid-cols-[1fr_260px]" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = { class: "grid gap-6 lg:grid-cols-[310px_1fr]" }
const _hoisted_10 = { class: "h-fit rounded-2xl border border-slate-100 bg-white shadow-sm lg:sticky lg:top-6" }
const _hoisted_11 = { class: "flex items-center justify-between border-b border-slate-100 px-4 py-3" }
const _hoisted_12 = {
  key: 0,
  class: "overflow-hidden divide-y divide-slate-100"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "block text-sm font-semibold" }
const _hoisted_15 = {
  key: 1,
  class: "m-4 rounded-lg border border-dashed border-slate-300 bg-slate-50 p-5 text-center"
}
const _hoisted_16 = {
  key: 0,
  class: "overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm"
}
const _hoisted_17 = { class: "border-b border-slate-100 bg-white px-6 py-6 sm:px-8" }
const _hoisted_18 = { class: "mb-4 flex flex-wrap items-center gap-2" }
const _hoisted_19 = { class: "rounded-full bg-[#003793]/10 px-3 py-1 text-sm font-semibold text-[#003793]" }
const _hoisted_20 = { class: "text-2xl font-bold text-slate-900 sm:text-3xl" }
const _hoisted_21 = { class: "mt-3 max-w-4xl text-sm leading-7 text-slate-600" }
const _hoisted_22 = { class: "divide-y divide-slate-100 px-6 sm:px-8" }
const _hoisted_23 = { class: "py-6" }
const _hoisted_24 = { class: "divide-y divide-slate-100 overflow-hidden rounded-lg border border-slate-100" }
const _hoisted_25 = { class: "flex gap-4" }
const _hoisted_26 = { class: "flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#003793] text-sm font-bold text-white" }
const _hoisted_27 = { class: "font-bold text-slate-900" }
const _hoisted_28 = { class: "mt-1 text-sm leading-7 text-slate-600" }
const _hoisted_29 = {
  key: 1,
  class: "rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-sm"
}

import { computed, defineComponent, h, ref, watch, type CSSProperties } from "vue";
import AppSelect from '@/components/input/AppSelect.vue';
import { usePermissions } from "@/hooks/usePermissions";
import {
  ADMIN_FULL_ROLES,
  BANTUAN_ROLES,
  CONTENT_ROLES,
  DANA_BANTUAN_ROLES,
  DASHBOARD_ROLES,
  FINANCE_ROLES,
  KEMITRAAN_ROLES,
  SECRETARIAT_ROLES,
  canAccess,
} from "@/utils/permissions";

interface GuideStep {
  title: string;
  description: string;
}

interface GuideItem {
  title: string;
  description: string;
}

interface AdminDocumentation {
  id: string;
  title: string;
  category: string;
  route?: string;
  summary: string;
  tableColumns: GuideItem[];
  filters: GuideItem[];
  formFields: GuideItem[];
  buttons: GuideItem[];
  statusValues: GuideItem[];
  steps: GuideStep[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminGuideView',
  setup(__props) {

const guideIconPaths: Record<string, string[]> = {
  "Kolom yang Ditampilkan": [
    "M4.5 6.75h15",
    "M4.5 12h15",
    "M4.5 17.25h15",
    "M8.25 4.5v15",
    "M15.75 4.5v15",
  ],
  "Filter dan Pencarian": [
    "m21 21-4.35-4.35",
    "M10.5 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z",
    "M5.25 7.5h10.5",
    "M7.5 10.5h6",
  ],
  "Field Form": [
    "M6.75 3.75h7.5L18 7.5v12.75H6.75V3.75Z",
    "M14.25 3.75V7.5H18",
    "M9 11.25h6",
    "M9 14.25h6",
    "M9 17.25h3",
  ],
  "Tombol dan Aksi": [
    "M6 12h12",
    "m13.5 6 6 6-6 6",
    "M4.5 6.75h4.125",
    "M4.5 17.25h4.125",
  ],
  "Nilai Status / Opsi": [
    "M9 12.75 11.25 15 15.75 9",
    "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
  ],
};

const GuideSection = defineComponent({
  name: "GuideSection",
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    items: { type: Array as () => GuideItem[], required: true },
  },
  setup(props) {
    return () =>
      h("section", { class: "py-6" }, [
        h("div", { class: "mb-4 flex items-center gap-3" }, [
          h("div", { class: "flex h-9 w-9 items-center justify-center rounded-lg bg-[#003793]/10 text-[#003793]" }, [
            h(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-5 w-5",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "1.8",
              },
              (guideIconPaths[props.title] || [
                "M12 6.75h.008v.008H12V6.75Z",
                "M11.25 10.5H12v6.75h.75",
                "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
              ]).map((path) =>
                h("path", {
                  d: path,
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                })
              )
            ),
          ]),
          h("div", {}, [
            h("h3", { class: "text-lg font-bold text-slate-900" }, props.title),
            h("p", { class: "text-sm text-slate-500" }, props.description),
          ]),
        ]),
        h(
          "div",
          { class: "divide-y divide-slate-200 overflow-hidden rounded-lg border-2 border-slate-200" },
          props.items.map((item) =>
            h("div", { class: "grid gap-2 bg-white p-4 md:grid-cols-[180px_1fr] md:gap-0" }, [
              h("p", { class: "text-sm font-bold text-slate-900 md:border-r md:border-slate-200 md:pr-4" }, item.title),
              h("p", { class: "text-sm leading-6 text-slate-600 md:pl-4" }, item.description),
            ])
          )
        ),
      ]);
  },
});

const adminDocumentation: AdminDocumentation[] = [
  {
    id: "dashboard",
    title: "Dashboard",
    category: "Dashboard",
    route: "/dashboard",
    summary:
      "Dashboard adalah halaman utama untuk memantau ringkasan layanan IOM ITB, status pengajuan bantuan, progres donasi, pesanan merchandise, dan aktivitas terbaru.",
    tableColumns: [
      { title: "Kartu Pengajuan Perlu Proses", description: "Menampilkan total pengajuan yang belum selesai, dengan breakdown Bantuan IOM, Bantuan Kesehatan atau Bankes, dan Orang Tua Asuh atau OTA." },
      { title: "Kartu Bantuan Disetujui Bulan Ini", description: "Menampilkan jumlah bantuan yang disetujui pada bulan berjalan, dengan breakdown IOM, Bankes, dan OTA." },
      { title: "Kartu Pesanan Merchandise Baru", description: "Menampilkan jumlah pesanan merchandise baru yang perlu diperiksa." },
      { title: "Kartu Donasi Terkumpul", description: "Menampilkan total donasi, dengan breakdown Donasi IOM dan Orang Tua Asuh." },
      { title: "Kartu Total Anggota", description: "Menampilkan total anggota yang tercatat pada sistem." },
      { title: "Tabel Pengajuan Terbaru", description: "Menampilkan Nama Pemohon, NIM, dan Status pengajuan." },
      { title: "Tabel Aktivitas Admin", description: "Menampilkan Admin, Waktu, dan Perubahan Status." },
    ],
    filters: [],
    formFields: [],
    buttons: [
      { title: "Refresh Data", description: "Memuat ulang statistik, grafik, data terbaru, dan aktivitas admin dari backend." },
      { title: "Dropdown pada kartu Pengajuan Perlu Proses", description: "Membuka rincian jumlah pengajuan untuk Bantuan IOM, Bankes, dan OTA." },
      { title: "Dropdown pada kartu Bantuan Disetujui", description: "Membuka rincian jumlah bantuan disetujui untuk IOM, Bankes, dan OTA." },
    ],
    statusValues: [
      { title: "Status Tidak Diketahui", description: "Status awal ketika pengajuan belum memiliki status proses yang jelas." },
      { title: "Verifikasi Berkas", description: "Pengajuan sedang diperiksa kelengkapan berkasnya." },
      { title: "Wawancara", description: "Pemohon masuk tahap wawancara." },
      { title: "Menunggu", description: "Pengajuan sedang menunggu tindak lanjut." },
      { title: "Diproses", description: "Pengajuan sedang diproses admin." },
      { title: "Disetujui", description: "Pengajuan bantuan disetujui." },
      { title: "Ditolak", description: "Pengajuan bantuan ditolak." },
    ],
    steps: [
      { title: "Buka Dashboard", description: "Klik menu Dashboard pada sidebar." },
      { title: "Periksa kartu ringkasan", description: "Lihat jumlah pengajuan perlu proses, bantuan disetujui bulan ini, pesanan merchandise baru, donasi terkumpul, dan total anggota." },
      { title: "Buka breakdown kartu", description: "Klik kartu yang memiliki ikon panah untuk melihat rincian IOM, Bankes, atau OTA." },
      { title: "Periksa tabel terbaru", description: "Gunakan tabel pengajuan terbaru dan aktivitas admin untuk menentukan data yang perlu ditindaklanjuti." },
      { title: "Klik Refresh Data", description: "Gunakan tombol Refresh Data setelah ada perubahan data di menu lain." },
    ],
  },
  {
    id: "dashboard-pembayaran",
    title: "Dashboard Pembayaran",
    category: "Keuangan",
    route: "/dashboard-pembayaran",
    summary:
      "Dashboard Pembayaran digunakan untuk memantau pembayaran iuran sukarela dan kontribusi sukarela berdasarkan periode, jenis pembayaran, status pembayaran, metode pembayaran, fakultas, dan tren harian.",
    tableColumns: [
      { title: "Tanggal", description: "Tanggal pembayaran, diambil dari paidAt, date, atau createdAt." },
      { title: "Nama", description: "Nama pembayar atau donatur." },
      { title: "Jenis", description: "Jenis pembayaran, seperti iuran_sukarela atau kontribusi_sukarela." },
      { title: "Fakultas", description: "Nama fakultas yang terkait dengan pembayaran." },
      { title: "Nominal", description: "Nominal pembayaran dalam format rupiah." },
      { title: "Metode", description: "Metode pembayaran: manual atau midtrans." },
      { title: "Status", description: "Status pembayaran: pending, settlement, expired, failed, atau refunded." },
    ],
    filters: [
      { title: "Mulai", description: "Tanggal awal periode pembayaran." },
      { title: "Sampai", description: "Tanggal akhir periode pembayaran." },
      { title: "Jenis", description: "Pilihan: Semua, Iuran Sukarela, atau Kontribusi Sukarela." },
      { title: "Status", description: "Pilihan: Semua, Pending, Settlement, Expired, Failed, atau Refunded." },
    ],
    formFields: [],
    buttons: [
      { title: "Terapkan", description: "Menerapkan filter tanggal, jenis pembayaran, dan status pembayaran." },
    ],
    statusValues: [
      { title: "pending", description: "Pembayaran dibuat tetapi belum lunas." },
      { title: "settlement", description: "Pembayaran berhasil atau lunas." },
      { title: "expired", description: "Pembayaran melewati batas waktu." },
      { title: "failed", description: "Pembayaran gagal." },
      { title: "refunded", description: "Pembayaran dikembalikan." },
      { title: "manual", description: "Pembayaran dicatat manual oleh admin." },
      { title: "midtrans", description: "Pembayaran diproses melalui Midtrans." },
    ],
    steps: [
      { title: "Buka Dashboard Pembayaran", description: "Klik menu Dashboard Pembayaran pada sidebar." },
      { title: "Atur periode", description: "Isi tanggal Mulai dan Sampai untuk menentukan periode laporan." },
      { title: "Pilih jenis pembayaran", description: "Pilih Semua, Iuran Sukarela, atau Kontribusi Sukarela." },
      { title: "Pilih status pembayaran", description: "Pilih Pending, Settlement, Expired, Failed, Refunded, atau Semua." },
      { title: "Klik Terapkan", description: "Sistem akan memuat ulang ringkasan KPI, status pembayaran, jenis pembayaran, metode pembayaran, tren harian, dan tabel pembayaran terbaru." },
    ],
  },
  {
    id: "kegiatan",
    title: "Kegiatan",
    category: "Konten",
    route: "/kegiatan",
    summary:
      "Menu Kegiatan digunakan untuk mengelola publikasi kegiatan IOM ITB. Halaman ini menampilkan daftar kegiatan, filter status, pencarian, tombol buat kegiatan, editor, preview, publish, tarik ke draft, dan hapus.",
    tableColumns: [
      { title: "Judul", description: "Judul kegiatan yang ditampilkan pada kartu kegiatan." },
      { title: "Deskripsi", description: "Ringkasan konten kegiatan." },
      { title: "Status", description: "Draft atau Published." },
      { title: "Tanggal Status", description: "Jika Published menampilkan tanggal publikasi; jika Draft menampilkan tanggal pembaruan." },
      { title: "Gambar", description: "Thumbnail kegiatan." },
    ],
    filters: [
      { title: "Filter Semua", description: "Menampilkan kegiatan Draft dan Published." },
      { title: "Filter Draft", description: "Menampilkan kegiatan yang masih berstatus draft." },
      { title: "Filter Published", description: "Menampilkan kegiatan yang sudah dipublikasikan." },
      { title: "Pencarian", description: "Mencari kegiatan berdasarkan judul atau konten." },
    ],
    formFields: [
      { title: "Judul Kegiatan", description: "Diisi pada halaman editor sebagai judul utama kegiatan." },
      { title: "Deskripsi/Konten", description: "Diisi melalui rich text editor pada halaman editor." },
      { title: "Media", description: "Berisi gambar upload, URL gambar, atau URL YouTube." },
      { title: "Caption Media", description: "Keterangan untuk media yang sedang dipilih." },
      { title: "Thumbnail", description: "Dipilih dari media gambar dengan tombol Set as thumbnail." },
    ],
    buttons: [
      { title: "Buat Kegiatan", description: "Membuka editor kegiatan baru dengan parameter id new." },
      { title: "Edit", description: "Membuka editor kegiatan berdasarkan id kegiatan." },
      { title: "Publish", description: "Mengubah status kegiatan dari draft menjadi published." },
      { title: "Tarik ke Draft", description: "Mengubah status kegiatan dari published kembali ke draft." },
      { title: "Preview", description: "Membuka halaman preview kegiatan." },
      { title: "Hapus", description: "Menghapus kegiatan setelah konfirmasi." },
      { title: "Sebelumnya / Berikutnya", description: "Berpindah halaman daftar kegiatan." },
    ],
    statusValues: [
      { title: "draft", description: "Kegiatan belum dipublikasikan dan masih dapat diedit." },
      { title: "published", description: "Kegiatan sudah dipublikasikan." },
    ],
    steps: [
      { title: "Buka menu Kegiatan", description: "Klik menu Kegiatan pada sidebar." },
      { title: "Cari atau filter kegiatan", description: "Gunakan filter Semua, Draft, Published, atau kolom pencarian." },
      { title: "Buat kegiatan baru", description: "Klik Buat Kegiatan untuk membuka editor kegiatan baru." },
      { title: "Edit kegiatan lama", description: "Klik Edit pada kartu kegiatan yang ingin diubah." },
      { title: "Publish atau tarik ke draft", description: "Gunakan Publish untuk mempublikasikan; gunakan Tarik ke Draft untuk menyembunyikan kembali dari status published." },
      { title: "Hapus kegiatan", description: "Klik Hapus, lalu konfirmasi penghapusan." },
    ],
  },
  {
    id: "editor-kegiatan",
    title: "Editor Kegiatan",
    category: "Konten",
    route: "/kegiatan/new/edit",
    summary:
      "Editor Kegiatan digunakan untuk membuat dan menyunting konten kegiatan secara lengkap, termasuk judul, konten rich text, media gambar, URL gambar, YouTube, caption, urutan media, thumbnail, draft, preview, dan publish.",
    tableColumns: [],
    filters: [],
    formFields: [
      { title: "Judul kegiatan", description: "Input utama dengan placeholder Judul kegiatan." },
      { title: "Deskripsi/konten kegiatan", description: "Rich text editor untuk menulis isi kegiatan dalam format HTML." },
      { title: "Tipe Media", description: "Pilihan upload, url, atau youtube." },
      { title: "Upload gambar", description: "Input file image dengan multiple upload." },
      { title: "URL Gambar", description: "Input URL gambar dengan placeholder https://." },
      { title: "URL YouTube", description: "Input URL YouTube dengan placeholder https://youtube.com/watch?v=." },
      { title: "Caption", description: "Input keterangan untuk media yang sedang aktif." },
      { title: "Thumbnail", description: "Gambar utama kegiatan yang wajib ada sebelum publish." },
    ],
    buttons: [
      { title: "Kembali", description: "Kembali dari editor ke halaman sebelumnya." },
      { title: "Simpan Draft", description: "Menyimpan kegiatan sebagai draft." },
      { title: "Tarik ke Draft", description: "Mengubah kegiatan published menjadi draft." },
      { title: "Preview", description: "Membuka tampilan preview kegiatan." },
      { title: "Publish", description: "Mempublikasikan kegiatan. Judul dan thumbnail wajib diisi." },
      { title: "Panah kiri / kanan media", description: "Berpindah ke media sebelumnya atau berikutnya." },
      { title: "Set as thumbnail", description: "Menjadikan gambar yang sedang dipilih sebagai thumbnail." },
      { title: "Pindah kiri / kanan", description: "Mengubah urutan media." },
      { title: "Hapus media", description: "Menghapus media yang sedang dipilih." },
      { title: "Tambah Media", description: "Menambahkan URL gambar atau URL YouTube ke daftar media." },
    ],
    statusValues: [
      { title: "upload", description: "Menambahkan media dari file gambar lokal." },
      { title: "url", description: "Menambahkan media dari URL gambar." },
      { title: "youtube", description: "Menambahkan media dari URL YouTube." },
      { title: "draft", description: "Konten belum dipublikasikan." },
      { title: "published", description: "Konten sudah dipublikasikan." },
    ],
    steps: [
      { title: "Isi judul", description: "Tulis judul kegiatan pada input Judul kegiatan." },
      { title: "Tulis konten", description: "Tulis isi kegiatan pada rich text editor." },
      { title: "Tambahkan media", description: "Pilih tipe media upload, url, atau youtube, lalu masukkan file atau URL sesuai pilihan." },
      { title: "Atur caption dan urutan media", description: "Pilih media, isi Caption, lalu gunakan tombol pindah kiri atau kanan untuk mengatur urutan." },
      { title: "Pilih thumbnail", description: "Pilih media gambar dan klik Set as thumbnail." },
      { title: "Simpan atau publish", description: "Klik Simpan Draft untuk menyimpan sementara, Preview untuk melihat tampilan, atau Publish untuk mempublikasikan." },
    ],
  },
  {
    id: "merchandise",
    title: "Merchandise",
    category: "Produk",
    route: "/merchandise",
    summary:
      "Menu Merchandise digunakan untuk mengelola produk merchandise, termasuk gambar, nama produk, harga, stok, deskripsi, link, tanggal diperbarui, edit, dan hapus.",
    tableColumns: [
      { title: "Gambar", description: "Gambar produk merchandise." },
      { title: "Produk", description: "Nama produk merchandise." },
      { title: "Harga", description: "Harga produk." },
      { title: "Stok", description: "Jumlah stok produk." },
      { title: "Deskripsi", description: "Deskripsi produk." },
      { title: "Link", description: "Link eksternal produk." },
      { title: "Diperbarui", description: "Tanggal data terakhir diperbarui." },
      { title: "Aksi", description: "Berisi tombol Edit dan Hapus." },
    ],
    filters: [
      { title: "Pencarian", description: "Input dengan placeholder Cari merchandise." },
      { title: "Pagination", description: "Tombol Sebelumnya dan Berikutnya untuk berpindah halaman." },
    ],
    formFields: [
      { title: "name", description: "Nama produk merchandise. Wajib diisi." },
      { title: "stock", description: "Jumlah stok produk. Wajib diisi." },
      { title: "price", description: "Harga produk. Wajib diisi." },
      { title: "description", description: "Deskripsi produk. Wajib diisi." },
      { title: "image", description: "Gambar produk." },
      { title: "link", description: "Link produk atau halaman pembelian." },
    ],
    buttons: [
      { title: "Tambah Merchandise", description: "Membuka modal form untuk membuat produk baru." },
      { title: "Edit", description: "Membuka modal form dengan data produk yang dipilih." },
      { title: "Hapus", description: "Menghapus produk setelah konfirmasi." },
      { title: "Cancel", description: "Menutup modal tanpa menyimpan perubahan." },
      { title: "Submit", description: "Menyimpan data baru atau perubahan data merchandise." },
      { title: "Sebelumnya / Berikutnya", description: "Berpindah halaman data." },
    ],
    statusValues: [],
    steps: [
      { title: "Buka menu Merchandise", description: "Klik menu Merchandise pada sidebar." },
      { title: "Cari produk", description: "Gunakan input Cari merchandise untuk memfilter daftar produk." },
      { title: "Tambah produk", description: "Klik Tambah Merchandise, isi name, stock, price, description, image, dan link." },
      { title: "Simpan produk", description: "Klik Submit untuk menyimpan produk." },
      { title: "Edit produk", description: "Klik Edit pada baris produk, ubah field yang diperlukan, lalu klik Submit." },
      { title: "Hapus produk", description: "Klik Hapus pada baris produk, lalu konfirmasi penghapusan." },
    ],
  },
  {
    id: "transaksi-merchandise",
    title: "Transaksi Merchandise",
    category: "Produk",
    route: "/transactions",
    summary:
      "Menu Transaksi Merchandise digunakan untuk memantau pesanan merchandise dan mengubah status pesanan/pengiriman.",
    tableColumns: [
      { title: "Code", description: "Kode transaksi." },
      { title: "Username", description: "Nama pembeli." },
      { title: "Email", description: "Email pembeli." },
      { title: "No Telp", description: "Nomor telepon pembeli." },
      { title: "Address", description: "Alamat pembeli." },
      { title: "Merchandise", description: "Produk merchandise yang dibeli." },
      { title: "Qty", description: "Jumlah barang yang dipesan." },
      { title: "Status", description: "Status pesanan/pengiriman." },
      { title: "Payment", description: "Bukti atau informasi pembayaran." },
      { title: "Update at", description: "Tanggal data terakhir diperbarui." },
    ],
    filters: [
      { title: "Pencarian", description: "Pencarian transaksi pada halaman transaksi." },
      { title: "Pagination", description: "Tombol Sebelumnya dan Berikutnya untuk berpindah halaman." },
    ],
    formFields: [
      { title: "Status Pesanan / Pengiriman", description: "Select status untuk mengubah status transaksi." },
    ],
    buttons: [
      { title: "Edit", description: "Membuka modal update status transaksi." },
      { title: "Hapus", description: "Menghapus transaksi setelah konfirmasi." },
      { title: "Cancel", description: "Menutup modal tanpa menyimpan perubahan." },
      { title: "Submit", description: "Menyimpan status transaksi." },
      { title: "Sebelumnya / Berikutnya", description: "Berpindah halaman transaksi." },
    ],
    statusValues: [
      { title: "waiting", description: "Pesanan menunggu diproses." },
      { title: "on process", description: "Pesanan sedang diproses." },
      { title: "on delivery", description: "Pesanan sedang dikirim. Perubahan ke status ini mengirim notifikasi Email dan WhatsApp." },
      { title: "arrived", description: "Pesanan sudah tiba. Perubahan ke status ini mengirim notifikasi Email dan WhatsApp." },
      { title: "done", description: "Pesanan selesai. Perubahan ke status ini mengirim notifikasi Email dan WhatsApp." },
      { title: "canceled", description: "Pesanan dibatalkan." },
      { title: "denied", description: "Pesanan ditolak." },
    ],
    steps: [
      { title: "Buka menu Transaksi Merchandise", description: "Klik menu Transaksi Merchandise pada sidebar." },
      { title: "Periksa data transaksi", description: "Baca code, username, email, no telp, address, merchandise, qty, status, dan payment." },
      { title: "Ubah status pesanan", description: "Klik Edit, pilih status pada field Status Pesanan / Pengiriman, lalu klik Submit." },
      { title: "Pahami efek notifikasi", description: "Status on delivery, arrived, dan done akan otomatis mengirim notifikasi ke pembeli via Email dan WhatsApp." },
      { title: "Hapus transaksi", description: "Klik Hapus jika transaksi perlu dihapus, lalu konfirmasi." },
    ],
  },
  {
    id: "donasi",
    title: "Donasi",
    category: "Keuangan",
    route: "/donasi",
    summary:
      "Menu Donasi digunakan untuk melihat, memfilter, menambah, mengubah, dan memeriksa bukti donasi manual. Data pembayaran mendukung metode manual dan Midtrans.",
    tableColumns: [
      { title: "No", description: "Nomor urut data pada halaman aktif." },
      { title: "Tanggal", description: "Tanggal uang masuk atau tanggal data dibuat." },
      { title: "Donatur", description: "Nama donatur, email, dan nomor WhatsApp." },
      { title: "Jenis", description: "Jenis donasi." },
      { title: "Fakultas", description: "Fakultas yang terkait dengan donasi." },
      { title: "Kode", description: "Kode unik fakultas." },
      { title: "Nominal", description: "Nominal donasi dalam format rupiah." },
      { title: "Metode", description: "Manual atau Midtrans." },
      { title: "Status", description: "Status pembayaran." },
      { title: "Bukti Manual", description: "Tombol Lihat untuk membuka bukti bayar manual. Midtrans divalidasi dari status transaksi." },
    ],
    filters: [
      { title: "Per halaman", description: "Pilihan 5, 10, 20, atau 50 data per halaman." },
      { title: "Metode", description: "Pilihan Semua, Manual, atau Midtrans." },
      { title: "Status", description: "Pilihan Semua, Pending, Settlement, Expired, Failed, atau Refunded." },
      { title: "Jenis Donasi", description: "Pilihan Semua, Iuran Sukarela, Kontribusi Anggota, Kontribusi Donatur, Pembelian Merchandise, atau Kontribusi Sukarela." },
      { title: "Cari Nama", description: "Input dengan placeholder Ketik nama." },
    ],
    formFields: [
      { title: "Nama", description: "Nama donatur. Wajib diisi." },
      { title: "Email", description: "Email donatur." },
      { title: "No WA", description: "Nomor WhatsApp donatur." },
      { title: "Jenis Donasi", description: "Pilihan: iuran_sukarela, kontribusi_anggota, kontribusi_donatur, pembelian_merchandise, kontribusi_sukarela." },
      { title: "Fakultas", description: "Pilihan fakultas. Jika dipilih, nominal akhir ditambah kode unik fakultas." },
      { title: "Uang yang didonasi", description: "Nominal donasi. Wajib diisi." },
      { title: "Tanggal uang masuk", description: "Tanggal donasi masuk. Wajib diisi." },
      { title: "Bank", description: "Nama bank pembayaran." },
      { title: "Notifikasi melalui?", description: "Checkbox whatsapp dan email. Wajib dipilih." },
      { title: "Sembunyikan nama?", description: "Checkbox untuk menyembunyikan nama donatur." },
      { title: "Hamba Allah?", description: "Checkbox untuk menandai donatur sebagai Hamba Allah." },
      { title: "Bukti Transfer Manual", description: "Upload gambar bukti bayar manual jika ada. Tidak dipakai untuk Midtrans." },
    ],
    buttons: [
      { title: "Tambah Donasi", description: "Membuka form donasi manual." },
      { title: "Lihat", description: "Membuka bukti bayar manual pada kolom Bukti Manual." },
      { title: "Batal", description: "Menutup form donasi." },
      { title: "Simpan", description: "Menyimpan data donasi baru atau perubahan data donasi." },
      { title: "Sebelumnya / Berikutnya", description: "Berpindah halaman data donasi." },
    ],
    statusValues: [
      { title: "iuran_sukarela", description: "Jenis pembayaran iuran sukarela." },
      { title: "kontribusi_anggota", description: "Jenis kontribusi dari anggota." },
      { title: "kontribusi_donatur", description: "Jenis kontribusi dari donatur." },
      { title: "pembelian_merchandise", description: "Jenis pembayaran pembelian merchandise." },
      { title: "kontribusi_sukarela", description: "Jenis kontribusi sukarela." },
      { title: "pending", description: "Pembayaran belum lunas." },
      { title: "settlement", description: "Pembayaran berhasil/lunas." },
      { title: "expired", description: "Pembayaran kedaluwarsa." },
      { title: "failed", description: "Pembayaran gagal." },
      { title: "refunded", description: "Pembayaran dikembalikan." },
      { title: "manual", description: "Pembayaran dicatat manual." },
      { title: "midtrans", description: "Pembayaran melalui Midtrans." },
    ],
    steps: [
      { title: "Buka menu Donasi", description: "Klik menu Donasi pada sidebar." },
      { title: "Filter data", description: "Atur Per halaman, Metode, Status, Jenis Donasi, atau Cari Nama." },
      { title: "Tambah donasi manual", description: "Klik Tambah Donasi, isi semua field yang diperlukan, lalu klik Simpan." },
      { title: "Periksa bukti bayar manual", description: "Klik Lihat pada kolom Bukti Manual untuk donasi manual. Donasi Midtrans mengikuti status transaksi." },
      { title: "Pindah halaman", description: "Gunakan tombol Sebelumnya atau Berikutnya." },
    ],
  },
  {
    id: "fakultas",
    title: "Fakultas",
    category: "Master Data",
    route: "/fakultas",
    summary:
      "Menu Fakultas digunakan untuk mengelola master data fakultas dan kode unik 3 digit yang dipakai pada pembayaran donasi/iuran manual.",
    tableColumns: [
      { title: "Nama", description: "Nama fakultas." },
      { title: "Kode Unik", description: "Kode unik 3 digit." },
      { title: "Status", description: "Aktif atau Nonaktif." },
      { title: "Aksi", description: "Tombol Edit dan Hapus." },
    ],
    filters: [],
    formFields: [
      { title: "Nama Fakultas", description: "Nama fakultas, contoh FTI. Wajib diisi." },
      { title: "Kode Unik (3 digit)", description: "Kode unik maksimal 3 digit, contoh 001. Wajib diisi." },
      { title: "Aktif", description: "Checkbox untuk menentukan fakultas aktif atau nonaktif." },
    ],
    buttons: [
      { title: "+ Tambah Fakultas", description: "Membuka form tambah fakultas." },
      { title: "Edit", description: "Membuka form edit fakultas." },
      { title: "Hapus", description: "Menghapus fakultas setelah konfirmasi." },
      { title: "Batal", description: "Menutup form tanpa menyimpan." },
      { title: "Simpan", description: "Menyimpan data fakultas." },
    ],
    statusValues: [
      { title: "Aktif", description: "Fakultas dapat digunakan pada fitur pembayaran/donasi." },
      { title: "Nonaktif", description: "Fakultas tidak aktif." },
    ],
    steps: [
      { title: "Buka menu Fakultas", description: "Klik menu Fakultas pada sidebar." },
      { title: "Tambah fakultas", description: "Klik + Tambah Fakultas, isi Nama Fakultas, Kode Unik 3 digit, dan status Aktif." },
      { title: "Simpan data", description: "Klik Simpan untuk menyimpan data." },
      { title: "Edit data", description: "Klik Edit pada baris fakultas yang ingin diubah." },
      { title: "Hapus data", description: "Klik Hapus pada baris fakultas yang ingin dihapus." },
    ],
  },
  {
    id: "pengajuan-bantuan",
    title: "Pengajuan Bantuan",
    category: "Bantuan",
    route: "/pengajuan-bantuan",
    summary:
      "Menu Pengajuan Bantuan digunakan untuk meninjau submission bantuan dari Tally, membuka detail jawaban, mengubah status pengajuan, menambahkan catatan, dan melihat riwayat perubahan status.",
    tableColumns: [
      { title: "Tanggal Submit", description: "Tanggal submission masuk." },
      { title: "Kolom dari answersByLabel", description: "Kolom utama diambil dari label pertanyaan form Tally yang dikirim backend melalui payload answersByLabel." },
      { title: "Status", description: "Status proses pengajuan." },
      { title: "Last Update", description: "Tanggal perubahan terakhir." },
      { title: "Aksi", description: "Tombol Detail." },
    ],
    filters: [
      { title: "Pencarian", description: "Mencari data berdasarkan nilai di answersByLabel, misalnya nama atau NIM jika label tersebut ada pada form Tally." },
      { title: "Pagination", description: "Tombol Sebelumnya dan Berikutnya untuk berpindah halaman." },
    ],
    formFields: [
      { title: "Status", description: "Select status pengajuan pada modal detail." },
      { title: "Catatan", description: "Textarea dengan placeholder Tambahkan catatan (opsional)." },
      { title: "Label Pertanyaan dan Jawaban", description: "Modal detail menampilkan seluruh pasangan label dan jawaban dari answersByLabel." },
    ],
    buttons: [
      { title: "Detail", description: "Membuka modal Detail Pengajuan." },
      { title: "Simpan Perubahan", description: "Menyimpan perubahan status dan catatan." },
      { title: "Ya, Simpan", description: "Konfirmasi untuk menyimpan perubahan status." },
      { title: "Batal", description: "Membatalkan konfirmasi simpan." },
      { title: "Tutup", description: "Menutup modal detail." },
      { title: "Ya, Tutup", description: "Konfirmasi menutup modal ketika ada perubahan yang belum disimpan." },
      { title: "Tetap di sini", description: "Membatalkan penutupan modal dan tetap di modal detail." },
    ],
    statusValues: [
      { title: "TIDAK_DIKETAHUI", description: "Ditampilkan sebagai Status Tidak Diketahui." },
      { title: "VERIFIKASI_BERKAS", description: "Ditampilkan sebagai Verifikasi Berkas." },
      { title: "DIPANGGIL_WAWANCARA", description: "Ditampilkan sebagai Dipanggil Wawancara." },
      { title: "KEPUTUSAN_DITERIMA", description: "Ditampilkan sebagai Keputusan Diterima." },
      { title: "KEPUTUSAN_DITOLAK", description: "Ditampilkan sebagai Keputusan Ditolak." },
    ],
    steps: [
      { title: "Buka menu Pengajuan Bantuan", description: "Klik menu Pengajuan Bantuan pada sidebar." },
      { title: "Cari data pengajuan", description: "Gunakan kolom pencarian untuk menemukan submission berdasarkan nilai jawaban form Tally." },
      { title: "Buka detail", description: "Klik Detail untuk melihat seluruh label pertanyaan dan jawaban dari answersByLabel." },
      { title: "Ubah status", description: "Pilih salah satu status: Status Tidak Diketahui, Verifikasi Berkas, Dipanggil Wawancara, Keputusan Diterima, atau Keputusan Ditolak." },
      { title: "Isi catatan", description: "Isi Catatan jika perlu menjelaskan keputusan atau proses admin." },
      { title: "Simpan perubahan", description: "Klik Simpan Perubahan, lalu konfirmasi dengan Ya, Simpan." },
      { title: "Periksa riwayat", description: "Baca riwayat perubahan status pada modal detail untuk melihat waktu, keterangan, dan aktor perubahan." },
    ],
  },
  {
    id: "pendataan-anggota",
    title: "Pendataan Anggota",
    category: "Data Anggota",
    route: "/pendataan-anggota",
    summary:
      "Menu Pendataan Anggota digunakan untuk membaca submission pendaftaran anggota dari Tally. Halaman ini bersifat read-only pada frontend: admin dapat mencari, melihat tabel, dan berpindah halaman.",
    tableColumns: [
      { title: "No", description: "Nomor urut data pada halaman aktif." },
      { title: "Tanggal Submit", description: "Tanggal submission masuk." },
      { title: "Kolom dari answersByLabel", description: "Kolom dinamis dari label pertanyaan form Tally untuk pendataan anggota." },
    ],
    filters: [
      { title: "Pencarian", description: "Mencari nilai jawaban dari form Tally." },
      { title: "Pagination", description: "Tombol Sebelumnya dan Berikutnya untuk berpindah halaman." },
    ],
    formFields: [],
    buttons: [
      { title: "Sebelumnya", description: "Berpindah ke halaman sebelumnya." },
      { title: "Berikutnya", description: "Berpindah ke halaman berikutnya." },
    ],
    statusValues: [],
    steps: [
      { title: "Buka menu Pendataan Anggota", description: "Klik menu Pendataan Anggota pada sidebar." },
      { title: "Cari submission", description: "Gunakan kolom pencarian untuk menemukan data berdasarkan jawaban form." },
      { title: "Baca data tabel", description: "Periksa Tanggal Submit dan kolom jawaban yang ditampilkan dari answersByLabel." },
      { title: "Pindah halaman", description: "Gunakan tombol Sebelumnya atau Berikutnya." },
    ],
  },
  {
    id: "orangtua-asuh",
    title: "Orangtua Asuh",
    category: "Bantuan",
    route: "/orangtua-asuh",
    summary:
      "Menu Orangtua Asuh digunakan untuk membaca submission program Orang Tua Asuh dari Tally. Halaman ini bersifat read-only pada frontend: admin dapat mencari, melihat tabel, dan berpindah halaman.",
    tableColumns: [
      { title: "No", description: "Nomor urut data pada halaman aktif." },
      { title: "Tanggal Submit", description: "Tanggal submission masuk." },
      { title: "Kolom dari answersByLabel", description: "Kolom dinamis dari label pertanyaan form Tally untuk program Orang Tua Asuh." },
    ],
    filters: [
      { title: "Pencarian", description: "Mencari nilai jawaban dari form Tally." },
      { title: "Pagination", description: "Tombol Sebelumnya dan Berikutnya untuk berpindah halaman." },
    ],
    formFields: [],
    buttons: [
      { title: "Sebelumnya", description: "Berpindah ke halaman sebelumnya." },
      { title: "Berikutnya", description: "Berpindah ke halaman berikutnya." },
    ],
    statusValues: [],
    steps: [
      { title: "Buka menu Orangtua Asuh", description: "Klik menu Orangtua Asuh pada sidebar." },
      { title: "Cari submission", description: "Gunakan kolom pencarian untuk menemukan data berdasarkan jawaban form." },
      { title: "Baca data tabel", description: "Periksa Tanggal Submit dan kolom jawaban yang ditampilkan dari answersByLabel." },
      { title: "Pindah halaman", description: "Gunakan tombol Sebelumnya atau Berikutnya." },
    ],
  },
  {
    id: "dana-bantuan",
    title: "Dana Bantuan",
    category: "Bantuan",
    route: "/dana-bantuan",
    summary:
      "Menu Dana Bantuan digunakan untuk mengelola catatan bantuan berdasarkan nama, NIM, program studi, jenis bantuan, bulan, tahun, dan jumlah donasi.",
    tableColumns: [
      { title: "Nama", description: "Nama penerima bantuan." },
      { title: "NIM", description: "NIM penerima bantuan." },
      { title: "Program Studi", description: "Program studi penerima bantuan." },
      { title: "Jenis Bantuan", description: "Jenis bantuan yang diberikan." },
      { title: "Bulan", description: "Bulan bantuan." },
      { title: "Tahun", description: "Tahun bantuan." },
      { title: "Jumlah Donasi", description: "Nominal bantuan." },
      { title: "Aksi", description: "Tombol Edit dan Hapus." },
    ],
    filters: [
      { title: "Pagination", description: "Tombol Sebelumnya dan Berikutnya untuk berpindah halaman." },
    ],
    formFields: [
      { title: "Nama", description: "Nama penerima bantuan. Wajib diisi." },
      { title: "NIM", description: "NIM penerima bantuan. Wajib diisi." },
      { title: "Program Studi", description: "Program studi penerima. Wajib diisi." },
      { title: "Jenis Bantuan", description: "Pilihan: Biaya UKT, Biaya Hidup, Biaya Tugas Akhir, Biaya Kesehatan (Bagi yang membutuhkan dan bersifat darurat), Bantuan Orang Tua Asuh, Bantuan Lainnya." },
      { title: "Bulan", description: "Pilihan: Januari, Febuari, Maret, April, Mei, Juni, Juli, Agustus, September, Oktober, November, Desember." },
      { title: "Tahun", description: "Tahun bantuan. Wajib diisi." },
      { title: "Jumlah Donasi", description: "Nominal bantuan. Wajib diisi." },
    ],
    buttons: [
      { title: "Tambah", description: "Membuka form tambah dana bantuan." },
      { title: "Edit", description: "Membuka form edit dana bantuan." },
      { title: "Hapus", description: "Menghapus data dana bantuan setelah konfirmasi." },
      { title: "Cancel", description: "Menutup modal tanpa menyimpan." },
      { title: "Submit", description: "Menyimpan data dana bantuan." },
      { title: "Sebelumnya / Berikutnya", description: "Berpindah halaman data." },
    ],
    statusValues: [
      { title: "Biaya UKT", description: "Jenis bantuan untuk UKT." },
      { title: "Biaya Hidup", description: "Jenis bantuan untuk biaya hidup." },
      { title: "Biaya Tugas Akhir", description: "Jenis bantuan untuk tugas akhir." },
      { title: "Biaya Kesehatan (Bagi yang membutuhkan dan bersifat darurat)", description: "Jenis bantuan kesehatan darurat." },
      { title: "Bantuan Orang Tua Asuh", description: "Jenis bantuan program OTA." },
      { title: "Bantuan Lainnya", description: "Jenis bantuan di luar opsi utama." },
    ],
    steps: [
      { title: "Buka menu Dana Bantuan", description: "Klik menu Dana Bantuan pada sidebar." },
      { title: "Tambah data", description: "Klik Tambah, isi Nama, NIM, Program Studi, Jenis Bantuan, Bulan, Tahun, dan Jumlah Donasi." },
      { title: "Simpan data", description: "Klik Submit untuk menyimpan data." },
      { title: "Edit data", description: "Klik Edit pada baris data yang ingin diperbarui." },
      { title: "Hapus data", description: "Klik Hapus dan konfirmasi penghapusan." },
    ],
  },
  {
    id: "kemitraan",
    title: "Kemitraan",
    category: "Kemitraan",
    route: "/kemitraan",
    summary:
      "Menu Kemitraan digunakan untuk mengelola data mitra IOM ITB, termasuk nama mitra, PIC, nomor telepon PIC, deskripsi, logo, dan dokumen MoU PDF.",
    tableColumns: [
      { title: "Logo", description: "Logo mitra." },
      { title: "Nama Mitra", description: "Nama organisasi/perusahaan mitra." },
      { title: "Nama PIC", description: "Nama penanggung jawab mitra." },
      { title: "Nomor Telepon PIC", description: "Nomor telepon PIC." },
      { title: "Deskripsi", description: "Deskripsi singkat mitra." },
      { title: "MoU", description: "Dokumen MoU dalam format PDF." },
      { title: "Aksi", description: "Tombol Edit dan Hapus." },
    ],
    filters: [
      { title: "Pencarian", description: "Mencari data kemitraan pada halaman kemitraan." },
    ],
    formFields: [
      { title: "Nama Mitra", description: "Input nama mitra dengan placeholder mis. PT Example." },
      { title: "Nama PIC", description: "Input nama PIC dengan placeholder mis. Budi Santoso." },
      { title: "Nomor Telepon PIC", description: "Input nomor telepon dengan placeholder mis. 08123456789." },
      { title: "Deskripsi", description: "Textarea dengan placeholder Deskripsi singkat tentang mitra." },
      { title: "Logo", description: "Upload logo mitra." },
      { title: "MoU (PDF)", description: "Upload dokumen MoU dalam format PDF." },
    ],
    buttons: [
      { title: "Tambah Kemitraan", description: "Membuka modal tambah kemitraan." },
      { title: "Edit", description: "Membuka modal edit kemitraan." },
      { title: "Hapus", description: "Menghapus data kemitraan setelah konfirmasi." },
      { title: "Batal", description: "Menutup modal tanpa menyimpan." },
      { title: "Simpan", description: "Menyimpan data kemitraan." },
      { title: "Tombol X", description: "Menutup modal form." },
    ],
    statusValues: [],
    steps: [
      { title: "Buka menu Kemitraan", description: "Klik menu Kemitraan pada sidebar." },
      { title: "Tambah mitra", description: "Klik Tambah Kemitraan, isi Nama Mitra, Nama PIC, Nomor Telepon PIC, Deskripsi, Logo, dan MoU PDF." },
      { title: "Simpan data", description: "Klik Simpan untuk menyimpan data mitra." },
      { title: "Edit data", description: "Klik Edit pada baris mitra yang ingin diperbarui." },
      { title: "Hapus data", description: "Klik Hapus dan konfirmasi penghapusan." },
    ],
  },
  {
    id: "kegiatan-kemitraan",
    title: "Kegiatan Kemitraan",
    category: "Kemitraan",
    route: "/kegiatan-kemitraan",
    summary:
      "Menu Kegiatan Kemitraan digunakan untuk menghubungkan kegiatan dengan mitra, lokasi, periode, status, dan gambar publikasi.",
    tableColumns: [
      { title: "Mitra", description: "Nama mitra yang terhubung dengan kegiatan." },
      { title: "Nama Kegiatan", description: "Nama kegiatan kemitraan." },
      { title: "Deskripsi", description: "Deskripsi kegiatan." },
      { title: "Lokasi", description: "Lokasi kegiatan." },
      { title: "Status", description: "planned, ongoing, completed, atau cancelled." },
      { title: "Tanggal Mulai", description: "Tanggal mulai kegiatan." },
      { title: "Tanggal Selesai", description: "Tanggal selesai kegiatan." },
      { title: "Gambar", description: "Gambar kegiatan." },
      { title: "Aksi", description: "Tombol Edit dan Hapus." },
    ],
    filters: [
      { title: "Pencarian", description: "Mencari kegiatan kemitraan pada halaman kegiatan kemitraan." },
    ],
    formFields: [
      { title: "Mitra", description: "Select mitra dari data Kemitraan." },
      { title: "Nama Kegiatan", description: "Nama kegiatan. Wajib diisi." },
      { title: "Deskripsi", description: "Deskripsi kegiatan." },
      { title: "Lokasi", description: "Lokasi kegiatan." },
      { title: "Status", description: "Pilihan: planned, ongoing, completed, cancelled." },
      { title: "Tanggal Mulai", description: "Tanggal mulai kegiatan." },
      { title: "Tanggal Selesai", description: "Tanggal selesai kegiatan." },
      { title: "Gambar", description: "Upload gambar kegiatan." },
    ],
    buttons: [
      { title: "Tambah Kegiatan Kemitraan", description: "Membuka modal tambah kegiatan kemitraan." },
      { title: "Edit", description: "Membuka modal edit kegiatan kemitraan." },
      { title: "Hapus", description: "Menghapus kegiatan kemitraan setelah konfirmasi." },
      { title: "Batal", description: "Menutup modal tanpa menyimpan." },
      { title: "Simpan", description: "Menyimpan data kegiatan kemitraan." },
      { title: "Tombol X", description: "Menutup modal form." },
    ],
    statusValues: [
      { title: "planned", description: "Kegiatan direncanakan." },
      { title: "ongoing", description: "Kegiatan sedang berjalan." },
      { title: "completed", description: "Kegiatan selesai." },
      { title: "cancelled", description: "Kegiatan dibatalkan." },
    ],
    steps: [
      { title: "Buka menu Kegiatan Kemitraan", description: "Klik menu Kegiatan Kemitraan pada sidebar." },
      { title: "Tambah kegiatan", description: "Klik Tambah Kegiatan Kemitraan, pilih Mitra, isi Nama Kegiatan, Deskripsi, Lokasi, Status, Tanggal Mulai, Tanggal Selesai, dan Gambar." },
      { title: "Simpan data", description: "Klik Simpan untuk menyimpan kegiatan." },
      { title: "Edit data", description: "Klik Edit pada baris kegiatan yang ingin diperbarui." },
      { title: "Hapus data", description: "Klik Hapus dan konfirmasi penghapusan." },
    ],
  },
];

const guideRouteRoles: Record<string, string[]> = {
  "/dashboard": DASHBOARD_ROLES,
  "/dashboard-pembayaran": FINANCE_ROLES,
  "/kegiatan": CONTENT_ROLES,
  "/kegiatan/new/edit": CONTENT_ROLES,
  "/merchandise": FINANCE_ROLES,
  "/transactions": FINANCE_ROLES,
  "/donasi": FINANCE_ROLES,
  "/fakultas": FINANCE_ROLES,
  "/pengajuan-bantuan": BANTUAN_ROLES,
  "/pendataan-anggota": SECRETARIAT_ROLES,
  "/orangtua-asuh": BANTUAN_ROLES,
  "/dana-bantuan": DANA_BANTUAN_ROLES,
  "/kemitraan": KEMITRAAN_ROLES,
  "/kegiatan-kemitraan": KEMITRAAN_ROLES,
};

const getDocumentationRoles = (item: AdminDocumentation) => {
  if (item.route && guideRouteRoles[item.route]) {
    return guideRouteRoles[item.route];
  }

  return ADMIN_FULL_ROLES;
};

const { selectedRoleId } = usePermissions();
const searchKeyword = ref("");
const selectedCategory = ref("");
const selectedFeatureId = ref("");

const accessibleDocumentation = computed(() => {
  return adminDocumentation.filter((item) => canAccess(getDocumentationRoles(item), selectedRoleId.value));
});

const categories = computed(() => {
  return Array.from(new Set(accessibleDocumentation.value.map((item) => item.category))).sort();
});

const categoryOptions = computed(() => [
  { value: '', label: 'Semua kategori' },
  ...categories.value.map((c) => ({ value: c, label: c })),
]);

const filteredDocumentation = computed(() => {
  const keyword = searchKeyword.value.trim().toLowerCase();

  return accessibleDocumentation.value.filter((item) => {
    const matchCategory = selectedCategory.value
      ? item.category === selectedCategory.value
      : true;

    const searchableText = [
      item.title,
      item.category,
      item.summary,
      ...item.tableColumns.map((item) => `${item.title} ${item.description}`),
      ...item.filters.map((item) => `${item.title} ${item.description}`),
      ...item.formFields.map((item) => `${item.title} ${item.description}`),
      ...item.buttons.map((item) => `${item.title} ${item.description}`),
      ...item.statusValues.map((item) => `${item.title} ${item.description}`),
      ...item.steps.map((step) => `${step.title} ${step.description}`),
    ]
      .join(" ")
      .toLowerCase();

    const matchKeyword = keyword ? searchableText.includes(keyword) : true;

    return matchCategory && matchKeyword;
  });
});

const selectedFeature = computed(() => {
  return filteredDocumentation.value.find((item) => item.id === selectedFeatureId.value);
});

watch(filteredDocumentation, (items) => {
  if (!items.length) {
    selectedFeatureId.value = "";
    return;
  }

  const stillExists = items.some((item) => item.id === selectedFeatureId.value);

  if (!stillExists) {
    selectedFeatureId.value = items[0].id;
  }
}, { immediate: true });

watch(categories, (items) => {
  if (selectedCategory.value && !items.includes(selectedCategory.value)) {
    selectedCategory.value = "";
  }
});

const selectFeature = (featureId: string) => {
  selectedFeatureId.value = featureId;
};

const guideNavButtonStyle = (featureId: string): CSSProperties => {
  if (selectedFeatureId.value !== featureId) {
    return {};
  }

  return {
    boxShadow: "inset 6px 0 0 #ffffff, inset 0 0 0 1px rgba(255,255,255,0.12)",
  };
};

const resetFilter = () => {
  searchKeyword.value = "";
  selectedCategory.value = "";
  selectedFeatureId.value = accessibleDocumentation.value[0]?.id || "";
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10" }, null, -1)),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "text-2xl font-bold md:text-4xl" }, " Panduan Penggunaan Fitur Admin "),
          _createElementVNode("p", { class: "mt-2 max-w-3xl text-sm leading-relaxed text-blue-100" }, " Pusat dokumentasi penggunaan dashboard admin IOM ITB. Pilih menu di sisi kiri untuk melihat kolom, filter, form, tombol, status, dan langkah penggunaan fitur. ")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm font-medium text-blue-100" }, "Total Dokumentasi", -1)),
          _createElementVNode("p", _hoisted_5, _toDisplayString(filteredDocumentation.value.length) + " Menu", 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _cache[7] || (_cache[7] = _createElementVNode("label", {
            for: "search",
            class: "mb-2 block text-sm font-semibold text-slate-900"
          }, " Cari dokumentasi ", -1)),
          _createElementVNode("div", _hoisted_8, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4 text-slate-400" }, [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-5 w-5",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "1.5"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                })
              ])
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              id: "search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKeyword).value = $event)),
              type: "text",
              placeholder: "Cari: donasi, status, upload, fakultas, pembayaran...",
              class: "h-12 w-full rounded-lg border border-slate-200 bg-white py-0 pl-11 pr-4 text-sm text-slate-700 outline-none transition placeholder:text-slate-400 focus:ring-2 focus:ring-[#8c8c94]/20"
            }, null, 512), [
              [_vModelText, searchKeyword.value]
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "mb-2 block text-sm font-semibold text-slate-900" }, " Kategori ", -1)),
          _createVNode(AppSelect, {
            modelValue: selectedCategory.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedCategory).value = $event)),
            options: categoryOptions.value,
            "button-class": "h-12 py-0"
          }, null, 8, ["modelValue", "options"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("aside", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "text-base font-semibold text-slate-700" }, " Daftar Menu ", -1)),
          (searchKeyword.value || selectedCategory.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "text-xs font-semibold text-[#003793] hover:underline",
                onClick: resetFilter
              }, " Reset "))
            : _createCommentVNode("", true)
        ]),
        (filteredDocumentation.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDocumentation.value, (feature) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: feature.id,
                  type: "button",
                  class: _normalizeClass(["block w-full rounded-none px-5 py-3 text-left transition", 
                selectedFeatureId.value === feature.id
                  ? 'bg-[#003793] text-white'
                  : 'bg-white text-slate-700 hover:bg-slate-50 hover:shadow-[inset_4px_0_0_rgba(0,55,147,0.28)]'
              ]),
                  style: _normalizeStyle(guideNavButtonStyle(feature.id)),
                  onClick: ($event: any) => (selectFeature(feature.id))
                }, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(feature.title), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["mt-1 block text-xs", selectedFeatureId.value === feature.id ? 'text-white/75' : 'text-slate-500'])
                  }, _toDisplayString(feature.category), 3)
                ], 14, _hoisted_13))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("p", { class: "text-sm font-semibold text-slate-900" }, "Tidak ada hasil", -1),
              _createElementVNode("p", { class: "mt-1 text-xs leading-5 text-slate-500" }, " Coba ubah kata kunci atau kategori. ", -1)
            ]))]))
      ]),
      _createElementVNode("main", null, [
        (selectedFeature.value)
          ? (_openBlock(), _createElementBlock("article", _hoisted_16, [
              _createElementVNode("header", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(selectedFeature.value.category), 1),
                  (selectedFeature.value.route)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: selectedFeature.value.route,
                        class: "inline-flex items-center gap-1 rounded-full border border-slate-200 px-3 py-1 text-sm font-semibold text-slate-600 transition hover:border-[#003793]/30 hover:bg-[#003793]/5 hover:text-[#003793]"
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode(" Buka fitur ", -1),
                          _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-3.5 w-3.5",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            "stroke-width": "1.8"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              d: "M13.5 4.5H19.5M19.5 4.5V10.5M19.5 4.5L10.5 13.5"
                            }),
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              d: "M19.5 13.5V18.75A.75.75 0 0 1 18.75 19.5H5.25A.75.75 0 0 1 4.5 18.75V5.25A.75.75 0 0 1 5.25 4.5H10.5"
                            })
                          ], -1)
                        ]))]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("h2", _hoisted_20, _toDisplayString(selectedFeature.value.title), 1),
                _createElementVNode("p", _hoisted_21, _toDisplayString(selectedFeature.value.summary), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                (selectedFeature.value.tableColumns.length)
                  ? (_openBlock(), _createBlock(_unref(GuideSection), {
                      key: 0,
                      title: "Kolom yang Ditampilkan",
                      description: "Kolom atau informasi utama yang dapat dilihat admin pada halaman ini.",
                      items: selectedFeature.value.tableColumns
                    }, null, 8, ["items"]))
                  : _createCommentVNode("", true),
                (selectedFeature.value.filters.length)
                  ? (_openBlock(), _createBlock(_unref(GuideSection), {
                      key: 1,
                      title: "Filter dan Pencarian",
                      description: "Kontrol yang digunakan untuk menyaring atau mencari data.",
                      items: selectedFeature.value.filters
                    }, null, 8, ["items"]))
                  : _createCommentVNode("", true),
                (selectedFeature.value.formFields.length)
                  ? (_openBlock(), _createBlock(_unref(GuideSection), {
                      key: 2,
                      title: "Field Form",
                      description: "Field yang perlu diisi saat membuat atau mengubah data.",
                      items: selectedFeature.value.formFields
                    }, null, 8, ["items"]))
                  : _createCommentVNode("", true),
                _createVNode(_unref(GuideSection), {
                  title: "Tombol dan Aksi",
                  description: "Tombol yang tersedia serta fungsi masing-masing tombol.",
                  items: selectedFeature.value.buttons
                }, null, 8, ["items"]),
                (selectedFeature.value.statusValues.length)
                  ? (_openBlock(), _createBlock(_unref(GuideSection), {
                      key: 3,
                      title: "Nilai Status / Opsi",
                      description: "Nilai pilihan atau status yang digunakan pada fitur ini.",
                      items: selectedFeature.value.statusValues
                    }, null, 8, ["items"]))
                  : _createCommentVNode("", true),
                _createElementVNode("section", _hoisted_23, [
                  _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"mb-4 flex items-center gap-3\"><div class=\"flex h-9 w-9 items-center justify-center rounded-lg bg-[#003793]/10 text-[#003793]\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-5 w-5\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"1.7\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.25 6.75H21M8.25 12H21M8.25 17.25H21M3.75 6.75H3.758V6.758H3.75V6.75ZM3.75 12H3.758V12.008H3.75V12ZM3.75 17.25H3.758V17.258H3.75V17.25Z\"></path></svg></div><div><h3 class=\"text-lg font-bold text-slate-900\">Cara Menggunakan</h3><p class=\"text-sm text-slate-500\">Urutan penggunaan fitur dari awal sampai selesai.</p></div></div>", 1)),
                  _createElementVNode("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFeature.value.steps, (step, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${selectedFeature.value.id}-${index}`,
                        class: "bg-white p-4"
                      }, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(index + 1), 1),
                          _createElementVNode("div", null, [
                            _createElementVNode("h4", _hoisted_27, _toDisplayString(step.title), 1),
                            _createElementVNode("p", _hoisted_28, _toDisplayString(step.description), 1)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_29, [...(_cache[13] || (_cache[13] = [
              _createElementVNode("h2", { class: "text-xl font-bold text-slate-900" }, "Dokumentasi tidak ditemukan", -1),
              _createElementVNode("p", { class: "mt-2 text-sm text-slate-600" }, " Ubah kata kunci pencarian atau pilih kategori lain. ", -1)
            ]))]))
      ])
    ])
  ]))
}
}

})